import classNames from "classnames";

type LogoCircleProps = {
  className?: string;
};

const LogoCircle: React.FC<LogoCircleProps> = ({ className }) => (
  <div className={classNames("logo-circle", className)}>
    <img src="/logo-circle.svg" alt="Electric City Aquarium logo" loading="lazy" decoding="async" />
  </div>
);

export default LogoCircle;
